import { Outlet } from "react-router-dom";
import Navigation from "@components/Navigation";
import Footer from "@components/Footer";

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
